import { EPageKind } from '../../types/page';

export function isDefaultPage(pageKind: EPageKind) {
  return pageKind === EPageKind.Default;
}
